import Loadable from '../../components/Loadable';
import { lazy } from 'react';

const AccDashboard = Loadable(lazy(() => import('./AccDashboard')));
const Payment = Loadable(lazy(() => import('./Payment')));
const Receipt = Loadable(lazy(() => import('./Receipt')));
const AccMaster = Loadable(lazy(() => import('./AccMaster')));
const Ledger = Loadable(lazy(() => import('./Ledger')));
const DailyExpense = Loadable(lazy(() => import('./DailyExpense')));
const ExpenseLedger = Loadable(lazy(() => import('./ExpenseLedger')));

const accRoutes = [
  { path: '/accdashboard', element: <AccDashboard /> },
  { path: '/payment', element: <Payment /> },
  { path: '/receipt', element: <Receipt /> },
  { path: '/accmaster', element: <AccMaster /> },
  { path: '/ledger', element: <Ledger /> },
  { path: '/dailyexpense', element: <DailyExpense /> },
  { path: '/dailyexpense/ledger', element: <ExpenseLedger /> },
];

export default accRoutes;
